import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="container">
        <h1 className="hero-title">Преміум догляд для вашого волосся</h1>
      </div>
      <div className="hero-image-fullwidth">
        <img 
          src="/img/5.png" 
          alt="MONXUAN" 
          className="hero-image"
        />
      </div>
    </section>
  );
};

export default Hero;